export enum PricingUnitEnum {
  PALLET = 'PALLET',
  KILOGRAM = 'KILOGRAM',
  UNIT = 'UNIT',
  COL = 'COL',
  LDM = 'LDM',
  KILOMETER = 'KILOMETER',
}
